import React, {useState} from "react";


const fields = [
    {
        "key": "config",
        "label": "Device config",
        "containerType": "MdmDevice",
        "fieldType": "MdmDeviceConfiguration",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "customFields.model",
        "label": "Modelis gamintojas",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.unit",
        "label": "Matavimo vnt",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.meter_type",
        "label": "Įrenginio tipas",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.specification",
        "label": "Specifikacija",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.location",
        "label": "Vieta",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.start_date",
        "label": "Sumontavimo data",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.end_date",
        "label": "Išmontavimo data",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.initial_reading",
        "label": "Pradinis parodymas",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.final_reading",
        "label": "Paskutinis parodymas",
        "containerType": "MdmDevice",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "id",
        "label": "Device Id",
        "containerType": "MdmDevice",
        "fieldType": "UUID",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "identifier",
        "label": "Device identifier",
        "containerType": "MdmDevice",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "objectRelation",
        "label": "Object relation",
        "containerType": "MdmDevice",
        "fieldType": "DeviceObjectRelation",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "tags",
        "label": "Tags",
        "containerType": "MdmDevice",
        "fieldType": "Set",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdAt",
        "label": "Created at",
        "containerType": "MdmDevice",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdBy",
        "label": "Created by",
        "containerType": "MdmDevice",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedAt",
        "label": "Modified at",
        "containerType": "MdmDevice",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedBy",
        "label": "Modified by",
        "containerType": "MdmDevice",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "status",
        "label": "Device Status",
        "containerType": "MdmDevice",
        "fieldType": "MdmDeviceStatus",
        "inputType": null,
        "propertyType": "COMPUTED_FIELD",
        "leaf": false,
        "enum": null
    },
    {
        "key": "lastMeasurementDate",
        "label": "Last measurement date",
        "containerType": "MdmDeviceStatus",
        "fieldType": "OffsetDateTime",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "status",
        "label": "Status",
        "containerType": "MdmDeviceStatus",
        "fieldType": "DeviceStatus",
        "inputType": "ENUM",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": [
            {
                "key": "ONLINE",
                "label": "ONLINE"
            },
            {
                "key": "OFFLINE",
                "label": "OFFLINE"
            },
            {
                "key": "NO_DATA",
                "label": "NO_DATA"
            }
        ]
    },
    {
        "key": "lastMeasurement",
        "label": "Device last Measurement",
        "containerType": "MdmDevice",
        "fieldType": "Double",
        "inputType": "DECIMAL",
        "propertyType": "COMPUTED_FIELD",
        "leaf": false,
        "enum": null
    },
    {
        "key": "dummyValue",
        "label": "Dummy value",
        "containerType": "MdmDevice",
        "fieldType": "Any",
        "inputType": null,
        "propertyType": "COMPUTED_FIELD",
        "leaf": false,
        "enum": null
    },
    {
        "key": "createdAt",
        "label": "Created at",
        "containerType": "MdmDeviceConfiguration",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdBy",
        "label": "Created by",
        "containerType": "MdmDeviceConfiguration",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedAt",
        "label": "Modified at",
        "containerType": "MdmDeviceConfiguration",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedBy",
        "label": "Modified by",
        "containerType": "MdmDeviceConfiguration",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "mdmObject",
        "label": "Object",
        "containerType": "DeviceObjectRelation",
        "fieldType": "MdmObject",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "roleIdentifier",
        "label": "Role identifier",
        "containerType": "DeviceObjectRelation",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "roleInObject",
        "label": "Role in object",
        "containerType": "DeviceObjectRelation",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdAt",
        "label": "Created at",
        "containerType": "DeviceObjectRelation",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdBy",
        "label": "Created by",
        "containerType": "DeviceObjectRelation",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedAt",
        "label": "Modified at",
        "containerType": "DeviceObjectRelation",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedBy",
        "label": "Modified by",
        "containerType": "DeviceObjectRelation",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "address",
        "label": "Address",
        "containerType": "MdmObject",
        "fieldType": "MdmObject.Address",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "customFields.purpose",
        "label": "Paskirtis",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.type",
        "label": "Tipas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.renovated",
        "label": "Pastato tipas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.renovation_year",
        "label": "Renovacijos metai",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.construction_year",
        "label": "Statybos metai",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.new_construction",
        "label": "Naujos statybos",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.number_of_floors",
        "label": "Aukštų sk",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.number_of_lifts",
        "label": "Laiptinių sk",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.number_of_rooms",
        "label": "Butų sk",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.number_of_other_rooms",
        "label": "Kitų patalpų sk",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.heat_source",
        "label": "Šilumos medis",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.heat_source_type",
        "label": "Schema",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installed_heating_capacity",
        "label": "Instaliuota galia šildymui",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installed_capacity_kv",
        "label": "Instaliuota galia KV",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installed_cooling_capacity",
        "label": "Instaliuota galia vėdinimui",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.boiler",
        "label": "Magistralė - Boilerinė",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installation",
        "label": "Šildymas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installer",
        "label": "Pastato šildymo sistemos prižiurėtojas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.installation_date",
        "label": "Šildymo sistemos įrengimo data",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.ntr_code",
        "label": "NTR kodas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.usable_area",
        "label": "Šildomas plotas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.total_area",
        "label": "Bendras plotas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.average_usage",
        "label": "Vidutinis sąnaudų normatyvas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "customFields.maximal_usage",
        "label": "Maksimalus sąnaudų normatyvas",
        "containerType": "MdmObject",
        "fieldType": "Map",
        "inputType": "STRING",
        "propertyType": "CUSTOM_FIELD",
        "leaf": true,
        "enum": null
    },
    {
        "key": "description",
        "label": "Description",
        "containerType": "MdmObject",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "identifier",
        "label": "Object Identifier",
        "containerType": "MdmObject",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "location",
        "label": "Location",
        "containerType": "MdmObject",
        "fieldType": "MdmObject.Location",
        "inputType": null,
        "propertyType": "SIMPLE",
        "leaf": false,
        "enum": null
    },
    {
        "key": "tags",
        "label": "Tags",
        "containerType": "MdmObject",
        "fieldType": "Set",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "title",
        "label": "Object name",
        "containerType": "MdmObject",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdAt",
        "label": "Created at",
        "containerType": "MdmObject",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "createdBy",
        "label": "Created by",
        "containerType": "MdmObject",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedAt",
        "label": "Modified at",
        "containerType": "MdmObject",
        "fieldType": "Instant",
        "inputType": "UTC_DATE",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "modifiedBy",
        "label": "Modified by",
        "containerType": "MdmObject",
        "fieldType": "String",
        "inputType": "USER_ID",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "city",
        "label": "City",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "country",
        "label": "Country",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "fullAddress",
        "label": "Full address",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "houseNumber",
        "label": "House number",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "postCode",
        "label": "Post code",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "street",
        "label": "Street",
        "containerType": "MdmObject.Address",
        "fieldType": "String",
        "inputType": "STRING",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "latitude",
        "label": "Latitude",
        "containerType": "MdmObject.Location",
        "fieldType": "Double",
        "inputType": "DECIMAL",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    },
    {
        "key": "longitude",
        "label": "Longitude",
        "containerType": "MdmObject.Location",
        "fieldType": "Double",
        "inputType": "DECIMAL",
        "propertyType": "SIMPLE",
        "leaf": true,
        "enum": null
    }
]

type Field = {
    key: string;
    label: string;
    containerType: string;
    fieldType: string;
    inputType: string;
    propertyType: string;
    leaf: boolean;
    enum: string[];
}

const operators = [
    {
        "label": "Equals",
        "value": "EQUALS"
    },
    {
        "label": "Not Equals",
        "value": "NOT_EQUALS"
    },
    {
        "label": "Contains",
        "value": "CONTAINS"
    },
]

type AdvancedFilterProps = {
    type: string;
}

type FilterInternal= {
    op: string;
    field: Field[];
    value?: string
}

const initialFilter: FilterInternal[] = [{
    // field: ["objectRelation", "customFields.model"],
    field: [],
    op: 'CONTAINS',
    value: 'aaa'
}]

const AdvancedFilter = (props: AdvancedFilterProps) => {
  const [filters, setFilters] = useState<FilterInternal[]>(initialFilter);

  const addFilter = () => {
    setFilters([...filters, { field: [], op: 'CONTAINS', value: '' }]);
  };

  const removeFilter = (index: number) => {
    const newFilters = [...filters];
    newFilters.splice(index, 1);
    setFilters(newFilters);
  };

  const updateFilter = (index: number, key: string, value: any) => {
    const newFilters = [...filters];
    const filter = newFilters[index] as any;
    filter[key] = value;
    console.log("newFilters", newFilters);
    setFilters(newFilters);
  };

  const getOptions = (type: string) => {
    return fields.filter(f => f.containerType === type);
  }

  // recursive function to render field selector
  const renderFieldSelector = (filter: FilterInternal, filterIndex: number, currentLevel: number = 0) => {
    const options = getOptions(currentLevel === 0 ? props.type : filter.field[currentLevel - 1].fieldType);

    console.log("options", options);

    const needRecurse = (filter.field[currentLevel] && !filter.field[currentLevel].leaf) || false;

    return (
        <div className="flex items-center space-x-2">
          <span>lvl {currentLevel}</span>
          <select
              className="border rounded p-1"
              value={filter.field[currentLevel]?.key || ''}
              onChange={(e) => {
                const newPath = [...filter.field];
                newPath[currentLevel] = options.find(o => o.key === e.target.value);
                updateFilter(filterIndex, 'field', newPath);
              }}
          >
            <option value="">Select</option>
            {options.map((option: any) => (
                <option key={option.key} value={option.key}>
                  {option.label}
                </option>
            ))}
          </select>

          {/*  Recurse */}

        {needRecurse && renderFieldSelector(filter, filterIndex, currentLevel + 1)}

        {/*Input*/}
        { !needRecurse && filter.field.length &&
            <>
                <span>input</span>
                <input className="border rounded p-1"
                       type="text"
                       value={filter.value}
                       onChange={(e) => updateFilter(filterIndex, 'value', e.target.value)}
                       placeholder="Value"
                />
                <select
                    className="border rounded p-1"
                    value={filter.op}
                    onChange={(e) => updateFilter(filterIndex, 'op', e.target.value)}
                >
                    {operators.map((operator) => (
                        <option key={operator.value} value={operator.value}>
                            {operator.label}
                        </option>
                    ))}
                </select>
            </>
        }
        </div>
    );
  };

  const renderFilter = (filter: any, index: any) => {
    return (
        <div key={index} className="flex items-center space-x-2 mb-2">
          {renderFieldSelector(filter, index)}
          <button onClick={() => removeFilter(index)} className="text-red-500">
            X
          </button>
        </div>
    );
  };

    // field joined by dot
    const simplified = filters.map(f => {
        return {
            field: f.field.map(f => f.key).join('.'),
            op: f.op,
            value: f.value
        }}
    );

  return (
      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">Advanced Filter</h2>
        {filters.map(renderFilter)}
        <button
            onClick={addFilter}
            className="bg-blue-500 text-white px-4 py-2 rounded mt-2"
        >
          Add Filter
        </button>
        <pre className="mt-4 p-2 bg-gray-100 rounded">
        {JSON.stringify(simplified, null, 2)}
      </pre>
      </div>
  );
};

const DevSandbox = () => {

  return (
    <div>
      aaaa
      <AdvancedFilter type="MdmDevice"/>
    </div>
  );
};

export default DevSandbox;


